export default {
    name: 'Emri',
    tel: 'Telefoni',
    save: 'Ruaj',
    confirm: 'Konfirmo',
    cancel: 'Anulo',
    delete: 'Fshi',
    complete: 'Përfundo',
    loading: 'Duke u ngarkuar...',
    telEmpty: 'Ju lutemi plotësoni telefonin',
    nameEmpty: 'Ju lutemi plotësoni emrin',
    nameInvalid: 'Emër i pasaktë',
    confirmDelete: 'Jeni i sigurt që doni të fshini?',
    telInvalid: 'Numër telefoni i pasaktë',
    vanCalendar: {
        end: 'Fund',
        start: 'Fillimi',
        title: 'Kalendari',
        startEnd: 'Fillimi/Fundi',
        weekdays: ['Die', 'Hën', 'Mar', 'Mër', 'Enj', 'Pre', 'Shtu'],
        monthTitle: (year, month) => `${year}/${month}`,
        rangePrompt: (maxRange) => `Zgjidhni jo më shumë se ${maxRange} ditë`,
    },
    vanCascader: {
        select: 'Zgjidh',
    },
    vanContactCard: {
        addText: 'Shto informacion kontakti',
    },
    vanContactList: {
        addText: 'Shto kontakt të ri',
    },
    vanPagination: {
        prev: 'I mëparshmi',
        next: 'Tjetri',
    },
    vanPullRefresh: {
        pulling: 'Tërhiq për të rifreskuar...',
        loosing: 'Lësho për të rifreskuar...',
    },
    vanSubmitBar: {
        label: 'Gjithsej:',
    },
    vanCoupon: {
        unlimited: 'Pa kufi',
        discount: (discount) => `${discount * 10}% ulje`,
        condition: (condition) => `Minimumi ${condition}`,
    },
    vanCouponCell: {
        title: 'Kuponi',
        tips: 'Asnjë kupon',
        count: (count) => `Keni ${count} kupon`,
    },
    vanCouponList: {
        empty: 'Asnjë kupon',
        exchange: 'Shkëmbim',
        close: 'Mbyll',
        enable: 'I disponueshëm',
        disabled: 'I padisponueshëm',
        placeholder: 'Kodi i kuponit',
    },
    vanAddressEdit: {
        area: 'Zona',
        postal: 'Posta',
        areaEmpty: 'Ju lutemi zgjidhni zonën e marrjes',
        addressEmpty: 'Adresa nuk mund të jetë e zbrazët',
        postalEmpty: 'Kodi postar i pasaktë',
        defaultAddress: 'Cakto si adresë default',
        telPlaceholder: 'Telefoni',
        namePlaceholder: 'Emri',
        areaPlaceholder: 'Zona',
    },
    vanAddressEditDetail: {
        label: 'Adresa',
        placeholder: 'Adresa',
    },
    vanAddressList: {
        add: 'Shto adresë të re',
    },
};